/**
 * @fileoverview SCIAN sector, subsector, and branch selects for requirement creation.
 * @module components/RequirementCreationView/RequirementScianProfile
 */
import Select from "react-select";
import styles from "./index.module.css";

const SectorField = ({ sectors, form }) => {
  const {
    t,
    setRequirement,
    selectSubsectorRef,
    selectBranchRef,
    setSubsectors,
    setBranches,
  } = form;

  return (
    <div className={styles.profileColumn}>
      <label className={styles.label}>
        {t("components.requirementCreationModal.sector")}
      </label>
      <Select
        ref={form.selectSectorRef}
        options={sectors}
        onChange={(selectedOption) => {
          if (selectedOption) {
            setRequirement((prev) => ({
              ...prev,
              sector: selectedOption._id,
              subSector: null,
              rama: null,
            }));
            selectSubsectorRef.current.clearValue();
            selectBranchRef.current.clearValue();
            setSubsectors(selectedOption.subSectores ?? []);
            setBranches([]);
          }
        }}
        placeholder={t("components.requirementCreationModal.sectorPlaceholder")}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderRadius: "8px",
            borderColor: "#909092",
            width: "100%",
            height: "30px",
            fontSize: "16px",
            cursor: "pointer",
            textOverflow: "ellipsis",
            textWrap: "nowrap",
            textAlign: "left",
            maxLines: 1,
          }),
          container: (baseStyles) => ({
            ...baseStyles,
          }),
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "200px",
          }),
          input: (baseStyles) => ({
            ...baseStyles,
          }),
          option: (baseStyles) => ({
            ...baseStyles,
            cursor: "pointer",
          }),
          indicatorSeparator: () => ({ display: "none" }),
        }}
        getOptionValue={(option) => option.nombre}
        formatOptionLabel={(option) => <span>{option.nombre}</span>}
      />
    </div>
  );
};

const SubsectorField = ({ form }) => {
  const {
    t,
    requirement,
    subSectors,
    setRequirement,
    selectBranchRef,
    setBranches,
  } = form;

  return (
    <div className={styles.profileColumn}>
      <label className={styles.label}>
        {t("components.requirementCreationModal.subsector")}
      </label>
      <Select
        ref={form.selectSubsectorRef}
        isSearchable={false}
        options={subSectors}
        onChange={(selectedOption) => {
          if (selectedOption) {
            setRequirement((prev) => ({
              ...prev,
              subSector: selectedOption._id,
              rama: null,
            }));
            selectBranchRef.current.clearValue();
            setBranches(selectedOption.ramas ?? []);
          }
        }}
        isDisabled={!requirement.sector}
        placeholder={t(
          "components.requirementCreationModal.subsectorPlaceholder",
        )}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderRadius: "8px",
            borderColor: "#909092",
            width: "100%",
            height: "30px",
            fontSize: "16px",
            cursor: "pointer",
            textOverflow: "ellipsis",
            textWrap: "nowrap",
            textAlign: "left",
            maxLines: 1,
          }),
          container: (baseStyles) => ({
            ...baseStyles,
          }),
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "120px",
          }),
          input: (baseStyles) => ({
            ...baseStyles,
          }),
          option: (baseStyles) => ({
            ...baseStyles,
            cursor: "pointer",
          }),
          indicatorSeparator: () => ({ display: "none" }),
        }}
        getOptionValue={(option) => option.nombre}
        formatOptionLabel={(option) => <span>{option.nombre}</span>}
      />
    </div>
  );
};

const BranchField = ({ form }) => {
  const { t, requirement, branches, handleChange } = form;

  return (
    <div className={styles.profileColumn}>
      <label className={styles.label}>
        {t("components.requirementCreationModal.branch")}
      </label>
      <Select
        ref={form.selectBranchRef}
        isSearchable={false}
        options={branches}
        onChange={(selectedOption) => {
          if (selectedOption) {
            handleChange("rama", selectedOption._id);
          }
        }}
        isDisabled={!requirement.subSector}
        placeholder={t("components.requirementCreationModal.branchPlaceholder")}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderRadius: "8px",
            width: "100%",
            height: "30px",
            fontSize: "16px",
            cursor: "pointer",
            borderColor: "#909092",
          }),
          container: (baseStyles) => ({
            ...baseStyles,
          }),
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "120px",
          }),
          input: (baseStyles) => ({
            ...baseStyles,
          }),
          option: (baseStyles) => ({
            ...baseStyles,
            cursor: "pointer",
          }),
          indicatorSeparator: () => ({ display: "none" }),
        }}
        getOptionValue={(option) => option.nombre}
        formatOptionLabel={(option) => <span>{option.nombre}</span>}
      />
    </div>
  );
};

const RequirementScianProfile = ({ sectors, form }) => (
  <div className={styles.profileSection}>
    <SectorField sectors={sectors} form={form} />
    <SubsectorField form={form} />
    <BranchField form={form} />
  </div>
);

export default RequirementScianProfile;
